"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumberPortIn = exports.isHylaTradinForTransfer = exports.isTradinHYLA_TRADEIN_PORTIN = exports.isTradinPromotionHYLA_TRADEIN = exports.isTradinPromotionCheck = exports.isTradinPromotionCheckForNew = exports.isDependencyCompleted = exports.identifyPreviousSelection = exports.DeviceTypes = exports.LineFormType = exports.LNPFormType = exports.LNPSelection = exports.DeviceCardScreens = exports.promotionCategory = void 0;
var StateProvider_1 = require("../api/StateProvider");
var localdatastore_1 = require("../config/localdatastore");
var promotionCategory;
(function (promotionCategory) {
    promotionCategory["HYLA_TRADEIN_PORTIN"] = "HYLA_TRADEIN_PORTIN";
    promotionCategory["HYLA_TRADEIN"] = "HYLA_TRADEIN";
})(promotionCategory = exports.promotionCategory || (exports.promotionCategory = {}));
var DeviceCardScreens;
(function (DeviceCardScreens) {
    DeviceCardScreens["INITIAL"] = "INITIAL";
    DeviceCardScreens["CAREER_INFO"] = "CAREER_INFO";
    DeviceCardScreens["TRANSFER"] = "TRANSFER";
    DeviceCardScreens["ASSIGN"] = "ASSIGN";
    DeviceCardScreens["SUMMARY"] = "SUMMARY";
    DeviceCardScreens["COLLAPSED"] = "COLLAPSED";
    DeviceCardScreens["NOT_ASSIGNED"] = "NOT_ASSIGNED";
})(DeviceCardScreens = exports.DeviceCardScreens || (exports.DeviceCardScreens = {}));
var LNPSelection;
(function (LNPSelection) {
    LNPSelection["KEEP_MY_NUMBER"] = "KEEP_MY_NUMBER";
    LNPSelection["ASSIGN_NEW_NUMBER"] = "ASSIGN_NEW_NUMBER";
    LNPSelection["NO_SELECTION"] = "NO_SELECTION";
})(LNPSelection = exports.LNPSelection || (exports.LNPSelection = {}));
var LNPFormType;
(function (LNPFormType) {
    LNPFormType["ASSIGNED"] = "ASSIGNED";
    LNPFormType["TRANSFERRED"] = "TRANSFERRED";
    LNPFormType["NOT_ASSIGNED"] = "NOT_ASSIGNED";
})(LNPFormType = exports.LNPFormType || (exports.LNPFormType = {}));
var LineFormType;
(function (LineFormType) {
    LineFormType["KEEP_NUMBER"] = "Keep my number";
    LineFormType["NEW_NUMBER"] = "Get a new number";
})(LineFormType = exports.LineFormType || (exports.LineFormType = {}));
var DeviceTypes;
(function (DeviceTypes) {
    DeviceTypes["PHONE"] = "356718080111111";
    DeviceTypes["TABLET"] = "358548070111111";
    DeviceTypes["WEARABLE"] = "358643090111111";
    DeviceTypes["CONNECTED_CAR"] = "Connected car";
})(DeviceTypes = exports.DeviceTypes || (exports.DeviceTypes = {}));
function identifyPreviousSelection(losg, isBsseFlow) {
    if (losg.currentSelection && losg.currentSelection === LNPFormType.TRANSFERRED) {
        return LNPSelection.KEEP_MY_NUMBER;
    }
    else if (losg.currentSelection && losg.currentSelection === LNPFormType.ASSIGNED) {
        return LNPSelection.ASSIGN_NEW_NUMBER;
    }
    else if (losg.ppuAddress && losg.carrierInfo) {
        return LNPSelection.KEEP_MY_NUMBER;
    }
    else if (losg.ppuAddress && losg.carrierInfo === undefined &&
        losg.marketInfo && losg.marketInfo.serviceAreaName &&
        losg.location) {
        return LNPSelection.ASSIGN_NEW_NUMBER;
    }
    else if (isBsseFlow && losg.selectedCtn && losg.selectedCtn !== '') {
        return LNPSelection.ASSIGN_NEW_NUMBER;
    }
    else {
        return LNPSelection.NO_SELECTION;
    }
}
exports.identifyPreviousSelection = identifyPreviousSelection;
function isDependencyCompleted() {
    var personalInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'PersonalInfo');
    var billingAddressInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'BillingAddress');
    var shippingAddressInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'ShippingAddress');
    return (!!(personalInfo && personalInfo.fName) &&
        (!!(billingAddressInfo && billingAddressInfo.isUpdated) ||
            !!(shippingAddressInfo && shippingAddressInfo.isUpdated)));
}
exports.isDependencyCompleted = isDependencyCompleted;
function isTradinPromotionCheckForNew(losg) {
    return !!(losg && losg.portInTradeInInfo && losg.portInTradeInInfo._portinCustomerConsented
        && losg.portInTradeInInfo._promotionCategory === promotionCategory.HYLA_TRADEIN_PORTIN);
}
exports.isTradinPromotionCheckForNew = isTradinPromotionCheckForNew;
function isTradinPromotionCheck(losg) {
    return !!(losg && losg.portInTradeInInfo
        && (losg.portInTradeInInfo._promotionCategory === promotionCategory.HYLA_TRADEIN_PORTIN
            || (losg.portInTradeInInfo._promotionCategory === promotionCategory.HYLA_TRADEIN
                && !losg.portInTradeInInfo._portinCustomerConsented)));
}
exports.isTradinPromotionCheck = isTradinPromotionCheck;
function isTradinPromotionHYLA_TRADEIN(losg) {
    return !!(losg && losg.portInTradeInInfo && !losg.portInTradeInInfo._portinCustomerConsented
        && losg.portInTradeInInfo._promotionCategory === promotionCategory.HYLA_TRADEIN);
}
exports.isTradinPromotionHYLA_TRADEIN = isTradinPromotionHYLA_TRADEIN;
function isTradinHYLA_TRADEIN_PORTIN(losg) {
    return !!(losg.portInTradeInInfo
        && losg.portInTradeInInfo._promotionCategory === promotionCategory.HYLA_TRADEIN_PORTIN);
}
exports.isTradinHYLA_TRADEIN_PORTIN = isTradinHYLA_TRADEIN_PORTIN;
function isHylaTradinForTransfer(losg) {
    return !!(losg && losg.portInTradeInInfo && losg.portInTradeInInfo._hylaTradeInAvailable
        && losg.portInTradeInInfo._portinCustomerConsented);
}
exports.isHylaTradinForTransfer = isHylaTradinForTransfer;
function isNumberPortIn() {
    var numberPortIn = StateProvider_1.StateProvider.getStateManagerInstance().get(localdatastore_1.getNamespace('CHECKOUT'), 'numberPortIn');
    return !!(numberPortIn && numberPortIn.portIn);
}
exports.isNumberPortIn = isNumberPortIn;
//# sourceMappingURL=NumberSelectionUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/utils/NumberSelectionUtil.js
// module id = 817
// module chunks = 8